$("#newsletterButton").click(function() {
    MicroModal.show('modalNewsletter');
});

function loadRecaptchaNewsletter(form) {
    grecaptcha.execute(recaptchaKey,
        { action: 'newsletter' }).then(function (token) {
        var recaptchaResponse = document.getElementById('newsletter_recaptcha');
        recaptchaResponse.value = token;

        $.post('/newsletter/subscription', form.serializeArray(), function(data) {
            $('#newsletter-form').replaceWith(data.html);
            setTimeout(function () {
                initFormNewsletter();
            }, 250);
            if (data.result) {
                // if (typeof __ss_noform != 'undefined') {
                //     __ss_noform.push(['submit', null, sharpspring_endpoint]);
                // }
                eval(data.resultNewsletter);
                MicroModal.close('modalNewsletter');
                MicroModal.show('newsletter-form-modal');
                window.dataLayer =  window.dataLayer || [];
                dataLayer.push({
                    'event': 'submit',
                    'context_submitted': 'newsletter'
                });
                fbq_trackCustom('submit__newsletter');
            }
        });
    });
}

var submitHandlerNewsletter = function(e) {
    e.preventDefault();
    e.target.removeEventListener('submit', submitHandlerNewsletter, false);

    document.getElementById('newsletter-form-submit').classList.add('d-none');
    document.getElementById('newsletter-form-loader').classList.remove('d-none');

    var form = $(this);
    loadRecaptchaNewsletter(form);
};

function initFormNewsletter() {
    // console.log(document.getElementById('newsletter-form'));
    if (document.getElementById('newsletter-form')) {
        document.getElementById('newsletter-form').addEventListener("submit", submitHandlerNewsletter);
    }
}
initFormNewsletter();